var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"YaSiRegular p"},[_vm._v(" 特雷通集团主要业务是设计、品牌塑造、制造和分销，家具和生活用品的零售，以及贸易和服务。"),_c('br',{staticClass:"br1024"}),_vm._v(" 经过多年的发展，集团已经成长为一家跨国家居集团公司。 ")])
}]

export { render, staticRenderFns }